import { MOIS_TABS } from "./config";

export const FORMER_JURIDIQUE = [
  "GIE",
  "Individuelle",
  "SA",
  "SARL",
  "SARLU",
  "SAS",
  "SASU",
  "SAU",
  "SCI",
  "SCOPS",
];

export const NOTIFICATION_TYPE_DOCUMENT = 1;
export const NOTIFICATION_TYPE_FILE = 2;
export const NOTIFICATION_TYPE_MEETING = 3;
export const NOTIFICATION_TYPE_SHARE_DETAILS = 4;

export const NOTIFICATION_TYPES = [
  NOTIFICATION_TYPE_DOCUMENT,
  NOTIFICATION_TYPE_FILE,
  NOTIFICATION_TYPE_MEETING,
  NOTIFICATION_TYPE_SHARE_DETAILS,
];

export const getMoisString = (mois) => {
  const value = parseInt(mois);
  if (value >= 1 && value <= 12) return MOIS_TABS[value - 1];
  else return "";
};
